import React from 'react';
import { ICON_BUTTON_TEXT_CLASS, iconButton } from '@noths/polaris-client-styles';

import * as styles from '../styles/SimpleModalHeader.styles';
import { IconClose } from 'client-ribbons-design-system/components/foundations/Iconography/IconClose';

const ICON_SIZE = 24;

export interface SimpleModalHeaderProps {
  onClose?: VoidFunction;
  title: string;
}

export const SimpleModalHeader = ({ onClose, title }: SimpleModalHeaderProps) => (
  <header css={styles.header}>
    <h3 css={styles.title}>{title}</h3>
    {onClose && (
      <button css={[iconButton, styles.closeBtn]} onClick={onClose}>
        <IconClose height={ICON_SIZE} width={ICON_SIZE} />
        <span className={ICON_BUTTON_TEXT_CLASS}>Close</span>
      </button>
    )}
  </header>
);
